
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增用印申请
export function addTheChapterApply(params) {
    return post(`${HOST}the-chapter-apply/save`, params)
}
// 修改用印申请
export function updateTheChapterApply(params) {
    return post(`${HOST}the-chapter-apply/update`, params)
}
//用印申请列表
export function getTheChapterApply(params) {
    return get(`${HOST}the-chapter-apply/list`, params)
}
//用印申请草稿箱列表
export function TheChapterApplyDraftlist(params) {
    return get(`${HOST}the-chapter-apply/draftlist`, params)
}
//用印申请详情
export function TheChapterApplyDetial(params) {
    return get(`${HOST}the-chapter-apply/get`, params)
}
// 删除用印申请
export function delTheChapterApply(params) {
    return del(`${HOST}the-chapter-apply/delete`, params)
}







// WEBPACK FOOTER //
// ./src/views/ApplicationSeal/api/api.js